import styled from "styled-components";

const SectionCenter = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: white;
`;

export default SectionCenter;
